import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/cn";
import { PADDING_CLASS, type Scale } from "./tokens";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: Scale;
  withBorder?: boolean;
  shadow?: "none" | "xs" | "sm" | "md" | "lg" | "xl";
}

const SHADOW_CLASS = {
  none: "shadow-none",
  xs: "shadow-xs",
  sm: "shadow-sm",
  md: "shadow-md",
  lg: "shadow-lg",
  xl: "shadow-xl",
} as const;

/** Reemplazo de `<Card>` de Mantine · defaults idénticos (borde + padding lg + radius md + shadow sm). */
export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ padding = "lg", withBorder = true, shadow = "sm", className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "rounded-md bg-card text-card-foreground transition-shadow ease-out-quint duration-160",
        withBorder && "border border-border",
        PADDING_CLASS[padding],
        SHADOW_CLASS[shadow],
        className
      )}
      {...props}
    />
  )
);
Card.displayName = "Card";

/** Reemplazo de `<Paper>` de Mantine · como `Card` pero sin padding/shadow por default. */
export const Paper = forwardRef<HTMLDivElement, CardProps>(
  ({ padding, withBorder = true, shadow = "none", className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "rounded-md bg-card text-card-foreground",
        withBorder && "border border-border",
        padding && PADDING_CLASS[padding],
        SHADOW_CLASS[shadow],
        className
      )}
      {...props}
    />
  )
);
Paper.displayName = "Paper";
